module.exports = __webpack_public_path__ + "static/c_zzbae-300ff9de65cfaa646cf17b44293d3ffe.jpg";